export default __webpack_public_path__ + "static/media/sorry.3e664194.svg";